import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    margin: 0;
  }
`
